
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/my-resume",
      function () {
        return require("private-next-pages/profile/my-resume/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/my-resume"])
      });
    }
  